import { AnyAction } from 'redux';

import { TextWrapping } from '@neptune/shared/common-domain';

import { NThunkAction } from 'state/types';

import { storeState } from '../storage-utils';

import { getTextWrappingState } from './selectors';

export enum TextWrappingActionTypes {
  Set = 'SetTextWrapping',
}

export const setTextWrapping = (
  id: string,
  wrapping: TextWrapping,
  projectIdentifier: string,
): NThunkAction<void, AnyAction> => {
  return (dispatch, getState) => {
    dispatch({
      type: TextWrappingActionTypes.Set,
      payload: {
        projectIdentifier,
        id,
        wrapping,
      },
    });

    const wrappingState = getTextWrappingState(getState());
    storeState(wrappingState);
  };
};

export type TextWrappingActions = {
  type: TextWrappingActionTypes.Set;
  payload: {
    projectIdentifier: string;
    id: string;
    wrapping: TextWrapping;
  };
};
